/** Reports > High Moisture Lots: its crop filter lives in the URL so the view can be shared. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { HighMoistureReportPage } from "@/features/reports/high-moisture-report";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/reports/high-moisture")({
  validateSearch: reportSearch,
  beforeLoad: () => {
    if (!useAuth.getState().can("reports.high_moisture"))
      throw redirect({ to: "/reports" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <HighMoistureReportPage
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
